<template>
  <div id="worker">
  <el-dialog
    :title="workerName"
    :visible.sync="cardShow"
    width="30%">
    <span>工号：{{workerNo}}</span>
    <div class="item">
        <el-button style="padding: 3px 0" type="text" @click="checkDetail">详细信息</el-button>
    </div>
    <div class="item">
        <el-button style="padding: 3px 0" @click="checkHistory" type="text">历史轨迹</el-button>
    </div>
  </el-dialog>
  <el-button id="closeHisBt" v-show="historyShow" type="warning" @click="closeHistory" icon="el-icon-close" circle></el-button>
  <History ref="history" :specifictype="specifictype" v-show="historyShow"/>
  <el-button icon="el-icon-close" v-show="detailShow" circle id="wdetailClose" @click="detailShow=false"></el-button>
  <Detail ref="wdetail" v-show="detailShow"></Detail>
  </div>
  
</template>

<script>
import $ from 'jquery'
import axios from 'axios'
import History from "components/historyC.vue"
import Detail from "components/workerDetail.vue"
import {getAllWorker,findEmpByEquipmentNo} from "@/api/worker.js"
import {mapMutations} from "vuex"
import {
  Viewer,
  Ion,
  JulianDate,
  TimeIntervalCollection,
  VelocityOrientationProperty,
  Cartesian3,
  ClockRange,
  SampledPositionProperty,
  TimeInterval,
  Color,
  Math,
  Entity,
  EntityCollection,
  ScreenSpaceEventHandler,
  ScreenSpaceEventType,
  DistanceDisplayCondition,
  NearFarScalar,
  Cartesian2
} from 'cesium'

import CONSTANTS from "@/views/control/map/constants";
import MapUtil from '@/views/control/map/util/mapUtil';

export default {
  name: 'Worker',
  components: {
    History,
    Detail
  },
  data(){
    return {
      workderInterval:null,
      detailShow:false,
      historyShow:false,//历史轨迹查看
      cardShow:false,
      workerName:"",//人名
      workerNo:"",//工号
      empId:"",//工号
      specifictype:"0",//类型
      workers:[],
      workerEntities:[],//员工实体模型
      viewer:null,
      userId:undefined,
      username:"",//用户名
      password:"",//密码
      data:[
      ]
    }
  },
  props: {
  },
  methods:{
    ...mapMutations([
      'setpepopleCount'
    ]),
    closeHistory(){
      this.historyShow=false;
    },
    handleClose(){
    },
    checkDetail(workerNo){
      this.workerNo=workerNo;
      this.cardShow=false
      this.detailShow=true
      this.$refs.wdetail.init(workerNo);
      MapUtil.closeOverlay();
    },
    checkHistory(workerNo){
      this.cardShow=false;
      this.historyShow=true;
      this.$refs.history.checkHistory(workerNo);
      MapUtil.closeOverlay();
    },
    init(){
      let _this=this
      let username=this.username=this.D3Config.username
      let password=this.password=this.D3Config.password
      _this.workerLayer=MapUtil.getLayerByName(CONSTANTS.LAYER.WORKER);
      getAllWorker(username,password).then((res)=>{
        let workers=_this.workers=res.data.data;
        _this.workerLayer.clearLayer();
        if(workers.length>0){
          _this.setpepopleCount(workers.length)
           window.gisViewer.camera.setView({
              destination: Cartesian3.fromDegrees(workers[0].longitude,workers[0].latitude, 229),
              orientation: {
                  heading: Math.toRadians(6.213139363447363),
                  pitch: Math.toRadians(-90),
                  roll: 0.0
              }
          });
          let params=[];
          workers.map((obj) =>{
            params.push({"equipmentNo":obj.deviceNo});
            obj.workStatus=0;
          });
          findEmpByEquipmentNo(params).then((res1)=>{
            let workers1=res1.data.data;
            workers.map((obj) =>{
              let worker=workers1.filter(item=>item.equipmentNo==obj.deviceNo);
              if(worker.length>0){
                obj.workStatus=worker[0].workStatus;
              }
            });
            _this.workersData=workers;
            _this.workerLayer.addEntities(workers);
          })
        }
      })
      window.workerCheckDetail=_this.checkDetail;
      window.workerCheckHistory=_this.checkHistory;
      this.workderInterval=setInterval(this.updateWorkers,5000)//5秒定时更新
      //this.bindPick();
    },
    //定时更新
    updateWorkers(){
      let _this=this
      getAllWorker(this.username,this.password).then((res)=>{
        let workers=_this.workers=res.data.data;
        for(let i=0;i<workers.length;i++){
          let worker=this.workers=workers[i];
          let entity=_this.workerLayer.getEntityById(worker.deviceNo);
          _this.workersData.filter((item1)=>{
            if(item1.deviceNo==worker.deviceNo){
              item1.latitude=worker.latitude;
              item1.longitude=worker.longitude;
            }
          });
          if(entity){
            entity.position=Cartesian3.fromDegrees(worker.longitude,worker.latitude, CONSTANTS.ALTITUDE);
          }
        }
      })
    },

    bindPick(){
      let _this=this
      var handler =new ScreenSpaceEventHandler(window.gisViewer.scene.canvas);
      handler.setInputAction(function (movement) {
          var pick = window.gisViewer.scene.pick(movement.position);
          if (pick&&pick.id.type=='worker') {

            // 获取点击位置坐标
              _this.workerNo=pick.id.id
              _this.empId=pick.id.empId
              _this.workerName=pick.id.name
              _this.specifictype=pick.id.specifictype
              _this.cardShow=true
          }
      }, ScreenSpaceEventType.LEFT_CLICK);
    }
  },
  mounted(){
    
  },
  beforeDestroy() {
    this.workderInterval&&clearInterval(this.workderInterval)
  }
}
</script>
<style scoped>
.text {
    font-size: 14px;
  }

  .item {
    margin-bottom: 18px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 480px;
    position:absolute;
    top:10%;
    left:30%;
  }
  #closeHisBt{
    position: absolute;
    top: 10px;
    z-index: 1002;
    right: 8%;
  }
  #wdetailClose{
    position: absolute;
    top: 13%;
    left: 80%;
    z-index: 1003;
  }
</style>



